import React from "react";
import { VEHICLES } from "../../constants/vehicles";

const STATUS_OPTIONS = ["Pending", "Confirmed", "Completed", "Cancelled"];

function StatusBadge({ status = "" }) {
  const map = {
    Pending:   "bg-amber-50 text-amber-700 ring-amber-200 dark:bg-amber-900/20 dark:text-amber-300 dark:ring-amber-700/50",
    Confirmed: "bg-blue-50 text-blue-700 ring-blue-200 dark:bg-blue-900/20 dark:text-blue-300 dark:ring-blue-700/50",
    Completed: "bg-emerald-50 text-emerald-700 ring-emerald-200 dark:bg-emerald-900/20 dark:text-emerald-300 dark:ring-emerald-700/50",
    Cancelled: "bg-rose-50 text-rose-700 ring-rose-200 dark:bg-rose-900/20 dark:text-rose-300 dark:ring-amber-700/50",
  };
  const cls = map[status] || "bg-slate-50 text-slate-700 ring-slate-200 dark:bg-slate-800 dark:text-slate-200 dark:ring-slate-700";
  return (
    <span className={`inline-flex items-center rounded-full px-2.5 py-1 text-xs font-medium ring-1 ${cls}`}>
      {status}
    </span>
  );
}

export default function DayTripBookingsTable({
  bookings = [],
  onUpdateStatus,
  onDelete,
}) {

  const fmtDate = (iso) => {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return "-";
    return d.toLocaleDateString("en-AU", { day: "2-digit", month: "short", year: "numeric" });
  };

  const getDestinationLabel = (destination) => {
    const destinations = {
      "phillip-island": "Phillip Island",
      "mornington-peninsula": "Mornington Peninsula", 
      "wilsons-prom": "Wilsons Prom",
      "mount-buller": "Mount Buller"
    };
    return destinations[destination] || destination;
  };

  const getVehicleLabel = (vehicleId) => {
    if (!vehicleId || vehicleId === 0) return "Any vehicle";
    const vehicle = VEHICLES.find(v => v.id === vehicleId);
    return vehicle ? `${vehicle.model} (${vehicle.year})` : `Vehicle #${vehicleId}`;
  };

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full divide-y divide-gray-200 dark:divide-slate-700">
        <thead>
          <tr className="text-left text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400">
            <th className="px-3 py-2">Customer</th>
            <th className="px-3 py-2">Destination</th>
            <th className="px-3 py-2">Guests</th>
            <th className="px-3 py-2">Preferred Vehicle</th>
            <th className="px-3 py-2">Date</th>
            <th className="px-3 py-2">Status</th>
            <th className="px-3 py-2">Actions</th>
          </tr>
        </thead>

        <tbody className="divide-y divide-gray-100 dark:divide-slate-800 text-sm">
          {bookings.length === 0 && (
            <tr>
              <td className="px-3 py-6 text-center text-gray-500 dark:text-gray-400" colSpan={7}>
                No day trip bookings found.
              </td>
            </tr>
          )}

          {bookings.map((b) => (
            <tr key={b.id} className="hover:bg-gray-50 dark:hover:bg-slate-700/50">
              <td className="px-3 py-3">
                <div className="font-medium">{b.customer_name || "—"}</div>
                <div className="text-xs text-gray-500 dark:text-gray-400">
                  {b.email || ""}{b.email && b.phone ? " • " : ""}{b.phone || ""}
                </div>
              </td>

              <td className="px-3 py-3 whitespace-nowrap">
                {getDestinationLabel(b.destination)}
              </td>

              <td className="px-3 py-3 whitespace-nowrap">
                {b.number_of_guests || 0} {b.number_of_guests === 1 ? 'guest' : 'guests'}
              </td>

              <td className="px-3 py-3 whitespace-nowrap">
                {getVehicleLabel(b.preferred_vehicle)}
              </td>

              <td className="px-3 py-3 whitespace-nowrap">
                {fmtDate(b.date)}
              </td>

              <td className="px-3 py-3 whitespace-nowrap">
                <StatusBadge status={b.status} />
              </td>

              <td className="px-3 py-3">
                <div className="flex items-center gap-2">
                  <select
                    value={b.status}
                    onChange={(e) => {
                      const next = e.target.value;
                      if (next === "Cancelled" && !window.confirm("Mark this day trip as Cancelled?")) return;
                      onUpdateStatus && onUpdateStatus(b.id, next);
                    }}
                    className="rounded-lg border-gray-300 dark:border-slate-600 bg-white dark:bg-slate-800 text-sm"
                  >
                    {STATUS_OPTIONS.map((s) => (
                      <option key={s} value={s}>{s}</option>
                    ))}
                  </select>

                  <button
                    type="button"
                    onClick={() => onDelete && onDelete(b.id)}
                    className="inline-flex items-center justify-center rounded-lg px-3 py-2 text-sm font-medium text-white bg-rose-600 hover:bg-rose-700 active:bg-rose-800 focus:outline-none focus:ring-2 focus:ring-rose-400"
                    title="Delete day trip booking"
                  >
                    Delete
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
